import { Box } from "@mui/material";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface Props {
  page: number;
  setPage: (value: number) => void;
  total: number;
  limit: number;
}

const Pagination = ({ page, setPage, total, limit }: Props) => {
  return (
    <Box className="pagination pagination-sm mb-0">
      <Box className={`page-item ${page === 0 && "disabled"}`}>
        <span className="page-link" onClick={() => setPage(0)}>
          First
        </span>
      </Box>
      <Box className={`page-item ${page === 0 && "disabled"}`}>
        <span className="page-link px-3" onClick={() => setPage(page - 1)}>
          <ChevronLeftIcon className="text-icon small" />
        </span>
        <span className="sr-only">Previous</span>
      </Box>
      <Box className="page-item disabled">
        <span className="page-link text-nowrap">
          Page {page + 1} of {Math.ceil(total / limit)}
        </span>
      </Box>
      <Box
        className={`page-item ${
          page >= Math.ceil(total / limit) - 1 && "disabled"
        }`}
        data-bs-toggle="tooltip"
      >
        <span className="page-link px-3" onClick={() => setPage(page + 1)}>
          <ChevronRightIcon className="text-icon small" />
        </span>
        <span className="sr-only">Next</span>
      </Box>
      <Box
        className={`page-item ${
          page >= Math.ceil(total / limit) - 1 && "disabled"
        }`}
      >
        <span
          className="page-link"
          onClick={() => setPage(Math.ceil(total / limit) - 1)}
        >
          Last
        </span>
      </Box>
    </Box>
  );
};

export default Pagination;
